import * as _ from 'lodash';
import { ResetPasswordReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

export const initialState: ResetPasswordReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const resetPasswordReducer = createReducer(initialState, {
  RESET_PASSWORD_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = _.get(action, 'payload.data');
  },
  RESET_PASSWORD_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },
  RESET_PASSWORD_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: _.get(action, 'payload.response.data.detail'),
      done: false,
    };
  },
});

export default resetPasswordReducer;
